import { createFileRoute } from '@tanstack/react-router'
import { DefinitionsView } from '../../../components/group-steering/ResourcesViews'

export const Route = createFileRoute('/$org/group/definitions')({
    component: DefinitionsRoute,
})

function DefinitionsRoute() {
    const { org } = Route.useParams()
    return <DefinitionsView org={org} />
}
